export default "__VITE_ASSET__Dr$QnNjk__"